<!--  -->
<template>
  <div class="wechat">
    <div>
      <h1>Linking your wechat account</h1>
      <div class="wechat-intro">
        ZLR is continuously improving our services. In order for you to be the first to know about our improvements, we launched a new feature on our official WeChat account which will inform you via notification when you get any service-related messages. For instance, when our mentee sends in their PS, you will immediately receive a notice in the official Wechat account, therefore you won’t miss any important info updates.
        <br />
        <br />
        Please follow the steps below to register:<br />
        1. Use Wechat to scan the QR code, and follow our official account “再来人 小V”.<br />
        2. Press “Mentor”, and simply sign-in to your account.<br />
        Then you can be immediately informed whenever you get a notice.
        <br />
        <br />
        For mentors who don’t have Wechat yet:<br />
        If you don’t have Wechat, please download it from the app store. It is a widely used messaging and social media app in China that’s available in many different languages, and works on different platforms. After you create a Wechat account, press “Scan” inside the plus sign that’s on the top right corner. Then, you can follow the steps above to finish the set up.
      </div>
      <div class="wechat-img">
        <img :src="wechatImg"
             alt="">
      </div>
    </div>
  </div>
</template>

<script>
// image s
import wechatImg from '@/assets/images/other/qrcode.svg'
export default {
  name: 'wechat',
  components: {},
  data () {
    return {
      wechatImg
    }
  },
  computed: {},
  mounted () { },
  methods: {}
}
</script>
<style lang='less' scoped>
.wechat {
  margin-top: 40px;
  background: #ffffff;
  > div {
    padding: 24px 0 60px;
    width: 800px;
    margin: 0 auto;
  }
  h1 {
    font-size: 24px;
    color: rgba(0, 0, 0, 0.85);
    text-align: center;
    line-height: 36px;
    margin-bottom: 40px;
  }
  &-intro {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.85);
    line-height: 24px;
    line-height: 24px;
    margin-bottom: 40px;
  }
  &-img {
    text-align: center;
  }
}
</style>
